

export default {

    created() {
        let t = this;

    },
    activated() {
        this.loadData();
    },
    methods: {
        loadData() {

            let t = this;

            axios.get('coupon/' + getURLParams().id).then(res => {
                if (res.data.status == 1) {
                    let item = res.data.options.item;;
                    t.item = item;
                    t.pickable = item.quantity >= item.user_coupons_count;
                }
            });

        },

        pickCoupon() {
            let t = this;

            axios.post('coupon/pick/' + t.item.id,).then(res => {
                if (res.data.status == 1) {
                    let userCoupon = res.data.options.item;
                    let d = new Date(userCoupon.expired_at);
                    A.show('有效期截止到 ' + d.format('yyyy年MM月dd日') + '<br>请尽快使用~', '领取成功！', 'success').then(res => {
                        t.$router.replace('/address');
                    });
                }
                else if (res.data.status == 2) {
                    A.err('领取失败，优惠券已被抢光啦！').then(res => {
                        t.$router.replace('/menu');
                    });
                }
                else if (res.data.status == 3) {
                    A.err('您已领取过该优惠券。').then(res => {
                        t.$router.replace('/address');
                    });
                }
            });

        },


    },
    data() {
        return {
            item: null,
            pickable: false
        };
    }
};
